module.exports = __webpack_public_path__ + "static/media/ic_get_money.aa693451.svg";